import { Guide } from 'data/ui/guide/Guide';
import { SELECTOR_MATCH_ALL } from './reducer';

export const SELECT_GUIDE = 'SELECT_GUIDE';

export interface SelectGuideAction {
  type: typeof SELECT_GUIDE;
  guide: Guide;
}

export const COMPLETE_GUIDE = 'COMPLETE_GUIDE';

export interface CompleteGuideAction {
  type: typeof COMPLETE_GUIDE;
  actionDone: string;
}

export const STOP_GUIDE = 'STOP_GUIDE';

export interface StopGuideAction {
  type: typeof STOP_GUIDE;
}

export const MARK_GUI_READY = 'MARK_GUI_READY';

export interface MarkGUIReadyAction {
  type: typeof MARK_GUI_READY;
  selectors: string[] | typeof SELECTOR_MATCH_ALL;
}

export type GuideAction =
  | SelectGuideAction
  | CompleteGuideAction
  | StopGuideAction
  | MarkGUIReadyAction;
